import { Component } from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {MbHeaderComponent} from '../../common';
import {MBFooterComponent} from '../../common/mb-footer/mb-footer.component';

@Component({
  selector: 'app-citizen-layout',
  imports: [RouterOutlet, MbHeaderComponent, MBFooterComponent],
  templateUrl: './citizen-layout.component.html',
})
export class CitizenLayoutComponent {

}
